import axios from 'axios';

export interface AIConversionRequest {
  plainText: string;
  emailType?: string;
}

export interface AITweakRequest {
  originalHtml: string;
  tweakDescription: string;
}

export interface AIConversionResponse {
  success: boolean;
  htmlContent?: string;
  message?: string;
}

const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL?.replace('/api', '') || (process.env.NODE_ENV === 'development' ? 'http://localhost:5000' : 'https://node-mailer-production.up.railway.app'),
    timeout: 60000, // 60 seconds timeout for AI requests
});



export const aiApi = {
  convertToHtml: async (request: AIConversionRequest): Promise<AIConversionResponse> => {
    try {
      const response = await api.post<AIConversionResponse>('/api/ai/convert-to-html', request);
      return response.data;
    } catch (error: any) {
      console.error('AI API call error (convertToHtml):', error); // Log for debugging
      if (error?.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const data = error.response.data;
        let message = 'Failed to convert text to HTML';
        if (data) {
          if (typeof data === 'object' && data.message) {
            message = data.message;
          } else if (typeof data === 'string') {
            // Try to extract a meaningful message from string response
            message = data.length > 200 ? data.substring(0, 200) + '...' : data;
          } else {
            message = String(data);
          }
        } else {
          message = `Server returned ${error.response.status}`;
        }
        return {
          success: false,
          message
        };
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: 'No response from server - please check your connection or try again later'
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: error.message || 'An unexpected error occurred'
        };
      }
    }
  },

  tweakHtml: async (request: AITweakRequest): Promise<AIConversionResponse> => {
    try {
      const response = await api.post<AIConversionResponse>('/api/ai/tweak-html', request);
      return response.data;
    } catch (error: any) {
      console.error('AI API call error (tweakHtml):', error); // Log for debugging
      if (error?.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        const data = error.response.data;
        let message = 'Failed to tweak HTML';
        if (data) {
          if (typeof data === 'object' && data.message) {
            message = data.message;
          } else if (typeof data === 'string') {
            // Try to extract a meaningful message from string response
            message = data.length > 200 ? data.substring(0, 200) + '...' : data;
          } else {
            message = String(data);
          }
        } else {
          message = `Server returned ${error.response.status}`;
        }
        return {
          success: false,
          message
        };
      } else if (error.request) {
        // The request was made but no response was received
        return {
          success: false,
          message: 'No response from server - please check your connection or try again later'
        };
      } else {
        // Something happened in setting up the request that triggered an Error
        return {
          success: false,
          message: error.message || 'An unexpected error occurred'
        };
      }
    }
  }
};
